import { APPCONFIG } from "../../../../../../app.config"
import { ALERT_TYPE, ShowToastMessage, authActionlogout } from '@laramie/ui';
import { VALIDATION_MESSAGE } from "../../../../../../consts/validationMessage"
import encrypt from "../../../../../../utils/encrypt"
import { APIS } from "../../../../../../config/apis"
import { onRequestError, standardRequest } from "../../../../../../utils/requests"
import { validatePassword } from "../../../../../../utils/validator"
import { FormError, InputSecret, Modal } from "../../../../../common"
import { useForm, useFormErrors, useManagedContext } from "../../../../../hooks"
import { useDispatch } from "react-redux"
import { ssoEnabled, ssoLogout } from '../../../../../../utils/sso';
const ChangePasswordModal = ({ close, username }) => {
    const [formValues, formHandle] = useForm({ passwordActual: '', passwordNueva: '', passwordRepeat: '',})
    const dispatch = useDispatch()
    const { setIsLoading } = useManagedContext()

    const getErrors = () => {
        const errors = {}

        if (formValues.passwordActual === '') errors.passwordActual = VALIDATION_MESSAGE.REQUIRED
        if (formValues.passwordNueva === '') errors.passwordNueva = VALIDATION_MESSAGE.REQUIRED
        if (formValues.passwordRepeat === '') errors.passwordRepeat = VALIDATION_MESSAGE.REQUIRED
        else if (formValues.passwordNueva !== formValues.passwordRepeat) errors.passwordRepeat = 'Las contraseñas no coinciden'

        return errors
    }

    const getFormatErrors = () => {
        const errors = {}

        if (formValues.passwordNueva !== '') {
            const validation = validatePassword(formValues.passwordNueva)
            if (!validation.success) errors.passwordNueva = validation.message
        }

        return errors
    }

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    const onAccept = () => {
        if (!validate()) return

        setIsLoading(true)
        standardRequest(
            'POST',
            `${APIS.URLS.AUTH_USUARIO}/replace-password`,
            {
                username,
                oldPassword: encrypt(formValues.passwordActual),
                newPassword: encrypt(formValues.passwordNueva),
            },
        ).then(() => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'La contraseña fue cambiada correctamente', () => {
                setIsLoading(false)
                dispatch(authActionlogout())
                // Para entrar con la nueva, también hay que cerrar la sesión de Keycloak.
                if (ssoEnabled()) ssoLogout()
                else window.location.href = `${APPCONFIG.SITE.WEBAPP_PRINCIPAL}logout`
            })
        }).catch(error => {
            onRequestError(error)
            setIsLoading(false)
        })
    }

    return (
    <Modal
      size="md"
      title="Cambio de contraseña"
      onEscape={close}
      body={(
            <div className="row">

                <div className="col-12">
                    <InputSecret
                        title="Contraseña actual"
                        htmlFor="codigo"
                        type="password"
                        name="passwordActual"
                        value={formValues.passwordActual}
                        onChange={formHandle}
                        autoComplete="new-password"
                        required
                        invalid={!!errorOf('passwordActual')}
                    />
                    <FormError message={errorOf('passwordActual')} />
                </div>
                <div className="col-12">
                    <InputSecret
                        title="Contraseña nueva"
                        htmlFor="codigo"
                        type="password"
                        name="passwordNueva"
                        value={formValues.passwordNueva}
                        onChange={formHandle}
                        autoComplete="new-password"
                        required
                        invalid={!!errorOf('passwordNueva')}
                    />
                    <FormError message={errorOf('passwordNueva')} />
                </div>
                <div className="col-12">
                    <InputSecret
                        title="Repetir contraseña nueva"
                        htmlFor="codigo"
                        type="password"
                        name="passwordRepeat"
                        value={formValues.passwordRepeat}
                        onChange={formHandle}
                        autoComplete="new-password"
                        required
                        invalid={!!errorOf('passwordRepeat')}
                    />
                    <FormError message={errorOf('passwordRepeat')} />
                </div>
            </div>
      )}
      footer={(<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={close}>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={onAccept}>Aceptar</button>
      </>)}
    />
    )
}

export default ChangePasswordModal
